import { TextInput } from '@octano/global-ui';
import React, { useEffect, useState } from 'react';

function InputLoading({ inputLabel }: { inputLabel: string }) {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <TextInput
      disabled
      label={`${inputLabel} ${dots}`}
      name="loading"
      placeholder={`Cargando ${dots}`}
    />
  );
}

export default InputLoading;
